import React, { useState } from 'react';
import { Button, Flex, Layout } from 'antd';
import { useTranslation } from 'react-i18next';
import PermissionsError from '../Errors/Permission.js';

function ResetPassword(props) {
  const { t } = useTranslation();
  const [id, setUserId] = useState("");

  function ResetUserPassword() {
    fetch(`/api/user/${id}/admin-reset-password`, {
      method: 'GET'
    }
    ).then(response => response.json())
      .then(data => {
        if (data.success === 1) {
          alert(data.password);
        } else {
          alert('Invalid username!');
        }
      });
  }

  const pageStyle = { alignItems: 'center' };

  return (
    <>
      {props.userData && props.userData.role !== 'ADMIN' ? (
        <PermissionsError />
      ) : (
        <Layout style={pageStyle}>
          <div className="glass-panel" style={{ padding: '2rem', borderRadius: '16px', width: '60%' }}>
            <Flex
              vertical="true"
              align="center"
              gap="small">
              <input
                type="text"
                placeholder={t('Enter username')}
                value={id}
                onChange={(e) => setUserId(e.target.value)}
                style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd', background: 'rgba(255,255,255,0.8)' }}
              />
              <Button
                type="primary"
                shape="round"
                id="reset"
                danger="true"
                onClick={ResetUserPassword}
              >
                {t('Reset user password')}
              </Button>
            </Flex>
          </div>
        </Layout>
      )}
    </>
  );
}

export default ResetPassword;
